module.exports = __webpack_public_path__ + "static/media/development-blog-1.3045a16c.md";